import { useMutation } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'

/**
 * 解約予約の取り消し（BillingPage）。
 * 成功時は useCancelSubscription と同じく全体リロードでプランを反映する
 * （AuthContext 再取得を含む）。解約予約中の表示は UserPlan 由来のため、
 * 再取得しないと取り消し後も表示が残る。
 */
export function useResumeSubscription() {
  return useMutation({
    mutationFn: () => billingApi.resumeSubscription(),
    onSuccess: () => {
      window.location.reload()
    },
  })
}
